import React from "react";
import {
  rejectedCommentOptions,
  userRejectedCommentOptions,
} from "../../utils/data";
import { getValueFromLocalStorage, localStorageKey } from "../../utils/helper";

const RejectModel = ({
  setComment,
  comment,
  handleNoteChange,
  closeModal,
  handleSaveComment,
  error,
  isBlocked,
  setIsBlocked,
  isShowDropdown = true,
}) => {
  const userRole = getValueFromLocalStorage(localStorageKey.USERDATA, "role");

  return (
    <div className="relative flex w-[80%] flex-col items-center justify-center gap-3 rounded-lg bg-white p-8 shadow-lg md:w-[70%] lg:w-[50%]">
      <div className="flex w-full flex-col items-start justify-between gap-3 xl:flex-row">
        <div className="flex flex-row gap-1">
          <h2 className="text-sm font-semibold xl:text-lg">
            Add a reason for reject
          </h2>
          <p className="text-sm font-semibold text-textRed">*</p>
        </div>
        {isShowDropdown && (
          <select
            name="rejectedComments"
            id="rejectedComments"
            onChange={(e) => setComment(e.target.value)}
            className="w-full rounded-lg border border-gray-500 px-2 py-1 text-[12px] outline-none xxs:w-[180px] xxs:text-[14px]"
          >
            {userRole === "admin"
              ? rejectedCommentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))
              : userRejectedCommentOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
          </select>
        )}
      </div>
      <textarea
        className="w-full rounded border border-gray-300 p-2 "
        rows="4"
        onChange={handleNoteChange}
        placeholder="Enter your comments..."
        value={comment}
      />
      {userRole === "user" && (
        <div className="flex w-full items-center gap-2">
          <input
            type="checkbox"
            id="blockUser"
            className="h-4 w-4 cursor-pointer"
            checked={isBlocked}
            onChange={(e) => setIsBlocked(e.target.checked)}
          />
          <label
            htmlFor="blockUser"
            className="text-sm font-medium text-gray-700"
          >
            Don't show this profile again
          </label>
        </div>
      )}

      {error && (
        <span className="flex w-full flex-col justify-start gap-1 text-start text-xs text-textRed">
          {comment.length < 15 && <p>Comment must be at least 15 characters</p>}
        </span>
      )}
      <div className="flex w-full justify-end gap-2">
        <button
          className="rounded bg-gray-300 px-1 py-0.5 text-black md:px-4 md:py-2"
          onClick={closeModal}
        >
          Close
        </button>
        <button
          className="rounded bg-blue-500 px-1 py-0.5 text-white md:px-4 md:py-2"
          onClick={handleSaveComment}
        >
          Send response
        </button>
      </div>
    </div>
  );
};

export default RejectModel;
